<template>
  <TextareaValidator
    :config="{
      label: control.label,
      name: control.label,
      validate: control.required ? 'required' : '',
      value: value,
    }"
    :onlyBreakAtNewlines="onlyBreakAtNewlines"
    :resizeable="resizeable"
    :smallInput="smallInput"
    :tooltip="getTooltip()"
    @InputValidatorModel="handleChange"
  />
</template>

<script>
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';
import TextareaValidator from 'client/components/FormValidation/TextareaValidator.vue';

export default {
  name: 'DynamicControlsTextarea',

  inject: ['$validator'],

  components: {
    TextareaValidator,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    onlyBreakAtNewlines: {
      default: false,
      type: Boolean,
    },

    resizeable: {
      default: false,
      type: Boolean,
    },

    smallInput: {
      default: false,
      type: Boolean,
    },

    value: {
      default: '',
      type: String,
    },
  },
};
</script>
